import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/style.css";

const Footer = () => {
  return (
    <div className="footer row mx-0 hash" id="contact">
      <div className="col-md-6 col-sm-12">
        <div className="bg-white  p-3" style={{maxWidth: 300}}>
          <img
            alt=""
            src="/icon.png"
            width="50"
            height="50"
            className="d-inline-block"
          />
          <span className="pl-2 text-dark" style={{fontSize: 22}}>
            PrepWithMock
          </span>
        </div>
        <h5 className="text-white mt-5">
          Prepare the best way for your incoming interviews
        </h5>
      </div>
      <div className="col-md-6 col-sm-12 ">
        <h6 className="text-white ml-1">FOLLOW US ON</h6>
        <div>
          <span class="circle m-1">
            <span>
              <a href="https://www.facebook.com/" target="blank">
                <i class="fab fa-facebook fa-lg"></i>
              </a>
            </span>
          </span>
          <span class="circle m-1">
            <span>
              <a href="https://www.instagram.com/" target="blank">
                <i class="fab fa-instagram fa-lg" style={{fontSize: 25}}></i>
              </a>
            </span>
          </span>
          <span class="circle m-1">
            <span>
              <a href="https://www.youtube.com/" target="blank">
                <i class="fab fa-youtube fa-lg" style={{fontSize: 21}}></i>
              </a>
            </span>
          </span>
          <span class="circle m-1">
            <span>
              <a href="https://www.twitter.com/" target="blank">
                <i class="fab fa-twitter fa-lg"></i>
              </a>
            </span>
          </span>
          <span class="circle m-1">
            <span>
              <a href="https://www.linkedin.com/" target="blank">
                <i class="fab fa-linkedin fa-lg"></i>
              </a>
            </span>
          </span>
          <span class="circle m-1">
            <span>
              <a href="https://www.telegram.com/" target="blank">
                <i class="fab fa-telegram-plane fa-lg"></i>
              </a>
            </span>
          </span>
        </div>
        <h6 className="text-white ml-1 mt-3">CONTACT US</h6>
        <i class="fas fa-phone-alt fa-md text-white ml-1"></i>
        <span className="ml-3" style={{color: "#bdb7b7"}}>
          1800-123-3598
        </span>
        <br />
        <i class="fas fa-envelope fa-md text-white ml-1"></i>
        <span className="text-light ml-3">prepwithmock@gmail.com</span>
      </div>
    </div>
  );
};

export default Footer;
